import React from 'react'
import Slider from 'react-slick';
import Fade from "react-reveal/Fade"
import Slide from "react-reveal/Slide"
import BannerImg from '../../../images/banner-cell.png'

const SliderArea = () => {

    const settings={
        dots: true,
		infinite: true,
		speed: 50,
		autoplay: false,
		arrows: false,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
                
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: false,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: false,
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: false,
				}
			},
		]
    }
  return (
    <section className="slider-area home-four-slider" style = {{'marginTop':  '-1.5rem', 'backgroundColor': 'black'}}>
    <Slider className="slider-active" {...settings}>
      <div className="single-slider slider-bg slider-style-two" style={{'backgroundColor': 'black'}}>
        <div className="container custom-container-two">
          <div className="row">
            <div className="col-xl-6 col-lg-7 col-md-11">
              <div className="slider-content">

                  <Fade up delay={.4000}>
                  <h2>Explore VR Digital Cities And Clubs</h2>
                  </Fade>
                  <Fade up delay={.4000}>
                  <h6 style={{
                        background: "-webkit-linear-gradient(#ff6559, rgba(85, 0, 255, 0.88))",
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                        }}>
                        Innovative, Eco-friendly, Sustainable
                  </h6>
                  </Fade>
                  <Fade up delay={.6000}>
                  <p style={{fontSize: "1.2rem", fontWeight: "500"}}>Engage to Earn</p>
                  </Fade>
                  <Fade up delay={.8000}>
                  <a href="/#" className="btn btn-style-two" style={{'marginRight': '2.5rem'}}>Buy CIP on Pancakeswap </a>
                  </Fade>
                  <Fade up delay={.8000}>
                  <a href="/#" className="btn btn-style-two">Learn More </a>
                  </Fade>
               
               
              </div>
            </div>
          </div>
          {/* <div className="slider-img">
          <Slide right delay={.8000}>
          <img src={BannerImg} alt="" style = {{}}/>
          </Slide>
          </div> */}
         
        </div>
      </div>
      {/* <div className="single-slider slider-bg slider-style-two">
        <div className="container custom-container-two">
          <div className="row">
            <div className="col-xl-6 col-lg-7 col-md-11">
              <div className="slider-content">
                  <Fade up delay={.4000}>
                  <h6 data-animation="fadeInUp" data-delay=".4s">world gaming</h6>
                  </Fade>
                <Fade up delay={.4000}>
                <h2>Create <span>Manage</span> Matches</h2>
                </Fade>
                <Fade up delay={.6000}>
                <p>Find technology or people for digital projects in public sector and Find an individual specialist develope researcher.</p>
                </Fade>
                <Fade up delay={.8000}>
                <a href="/#" className="btn btn-style-two" >READ MORE</a>
                </Fade>
               
              </div>
            </div>
          </div>
          <div className="slider-img">
          <Slide right delay={.8000}>
          <img src="assets/img/slider/four_slider_img02.png" alt="" />
          </Slide>
          </div>
         
        </div>
      </div> */}
    </Slider>
  </section>
  )
}

export default SliderArea